import * as SeparatorPrimitive from "@radix-ui/react-separator";
import { cn } from "cn";
import type * as React from "react";

function Separator({
  className,
  orientation = "horizontal",
  decorative = true,
  ...props
}: React.ComponentProps<typeof SeparatorPrimitive.Root>) {
  return (
    <SeparatorPrimitive.Root
      data-slot="separator-root"
      decorative={decorative}
      orientation={orientation}
      className={cn(
        /* sorted */
        "shrink-0",
        "bg-bg-dark-low",
        "data-[orientation=horizontal]:h-px data-[orientation=horizontal]:w-full data-[orientation=vertical]:h-full data-[orientation=vertical]:w-px",
        className,
      )}
      {...props}
    />
  );
}

function SeparatorDot({
  className,
  ...props
}: React.ComponentProps<typeof Separator>) {
  return (
    <Separator
      orientation="vertical"
      decorative
      className={cn(
        /* sorted */
        "rounded-full bg-fill-dark-high",
        "data-[orientation=vertical]:size-0.5",
        className,
      )}
      {...props}
    />
  );
}

export { Separator, SeparatorDot };
